module.exports = __webpack_public_path__ + "media/images/google-play-badge-55-22c6f230739901e7d2e69c44c85c5c4c.png";